import { Toaster } from "src/vibe-code/rcm-v2/components/ui/toaster";
import { Toaster as Sonner } from "src/vibe-code/rcm-v2/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Index from "./pages/Index";
import MainLayout from "src/layouts/MainLayout/MainLayout";

const queryClient = new QueryClient();

const RCMApp = () => {
  return (
    <MainLayout page="rcm" isAdmin={true}>
      <div className="rcm-root min-h-full">
        <QueryClientProvider client={queryClient}>
          <Toaster />
          <Sonner />
          <Index />
        </QueryClientProvider>
      </div>
    </MainLayout>
  );
};

export default RCMApp;
